import React from "react";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { LanguageContext } from "../context/LanguageContext";
import { LoginContext } from "../context/LoginContext";
import aboutImg from "../img/about.png";

const About = () => {
  const navigate = useNavigate();
  const { login } = useContext(LoginContext);
  const { language } = useContext(LanguageContext);

  const handleLearn = () => {
    if (login) {
      navigate("/gallery");
    } else {
      navigate("/login");
    }
  };
  return (
    <div>
      {/* Dil seçeneğini kontrol edin */}
      {language === "en" ? (
        <div className="container">
          <div className="about-page row p-5 mt-4">
            <div className="col-sm-12 col-lg-6">
              <img
                className="rounded about-img"
                src={aboutImg}
                alt="aboutImg"
              />
            </div>
            <div className="col-sm-12 col-lg-6 text-center">
              <h4 className="display-2 text-center">About Us</h4>
              <p className="about-par">
                Welcome Art Lover! This platform brings a renewed sense of
                experimentation to the possibilities of artist-designed
                versions.
              </p>
              <button
                onClick={handleLearn}
                className="btn-page btn w-100 rounded"
              >
                Learn More!
              </button>
            </div>
          </div>
        </div>
      ) : (
        <div className="container">
          <div className="about-page row p-5 mt-4">
            <div className="col-sm-12 col-lg-6">
              <img
                className="rounded about-img"
                src={aboutImg}
                alt="aboutImg"
              />
            </div>
            <div className="col-sm-12 col-lg-6 text-center">
              <h4 className="display-2 text-center">Hakkımızda</h4>
              <p className="about-par">
                Yeniden üretime yönelik yaratıcı yaklaşımları vurgulamayı, nesne
                ve görüntülerin üretilmesi için kapsamlı süreçleri
                etkinleştirmeyi amaçlıyoruz.
              </p>
              <button
                onClick={handleLearn}
                className="btn-page btn w-100 rounded"
              >
                Daha Fazla!
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default About;
